import './HAccordion.scss';

import * as tsx from 'vue-tsx-support';
import { PropType, VNode } from 'vue';
import { ResolvedLanugageData } from '~/server-middleware/data-server/adapter/ACCOAdapter/schemes';
import { AvailableLanguage, AccordionModule } from '~/schemes';
import { TypedHExpandButton } from '~/components';

const MAX_DEPTH = 3;

/**
 * アコーディオンモジュール
 *
 * bodyTypeによる表示制御：
 * - 'text': テキスト・画像のみ表示
 * - 'nested': 子アコーディオンのみ表示
 *
 * 3階層まで入れ子可能（depth 1-3）
 */
export const HAccordion = tsx.component({
  name: 'HAccordion',

  props: {
    value: {
      type: Object as PropType<
        ResolvedLanugageData<AccordionModule['properties'], AvailableLanguage>
      >,
      required: true,
    },
    depth: {
      type: Number,
      default: 1,
    },
  },

  render(): VNode {
    const baseLabel = this.value.label || (this.$t('label.details') as string);
    const label =
      this.value.isQuestion && this.value.label ? `Q. ${baseLabel}` : baseLabel;

    const imageUrl =
      this.value.image &&
      this.value.image.derived &&
      this.value.image.derived.main
        ? this.value.image.derived.main.url
        : '';

    const childDepth = this.depth + 1;

    return (
      <div
        class={[
          this.depth === 1 ? 'h-container' : '',
          'v-accordion-module',
          this.value.bodyType === 'nested' &&
            this.depth === 1 &&
            'v-accordion-module--nested-first',
          this.depth > 1 && 'v-accordion-module--nested-child',
          this.depth >= MAX_DEPTH && 'v-accordion-module--nested-last',
        ]}>
        <TypedHExpandButton
          label={label}
          class={[
            'v-accordion-module__label',
            {
              'v-accordion-module__label--question':
                (this.value.isQuestion && this.value.label) || this.depth > 1,
            },
          ]}>
          <div class="v-accordion-module__content">
            {this.value.bodyType === 'nested'
              ? this.value.children &&
                this.depth < MAX_DEPTH && (
                  <div class="v-accordion-module__children">
                    {this.value.children.map((child) => (
                      <HAccordion
                        key={child.key}
                        value={child.properties}
                        depth={childDepth}
                      />
                    ))}
                  </div>
                )
              : [
                  this.value.image && (
                    <div class="v-accordion-module__image-wrapper">
                      <img
                        src={imageUrl}
                        alt=""
                        class="v-accordion-module__image"
                      />
                    </div>
                  ),
                  this.value.text && (
                    <div
                      v-Wysiwyg={this.value.text}
                      class={[
                        'v-accordion-module__text',
                        {
                          'v-accordion-module__text--with-image': !!this.value
                            .image,
                        },
                      ]}></div>
                  ),
                ].filter(Boolean)}
          </div>
        </TypedHExpandButton>
      </div>
    );
  },
});
